// extracted by mini-css-extract-plugin
export default {"projectsContainer":"projects_projectsContainer__iS2Dn","title":"projects_title__-J4vP","items":"projects_items__xZEaO","projectsSection":"projects_projectsSection__gM91b"};